"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=function(e,r){(null==r||r>e.length)&&(r=e.length);for(var t=0,n=new Array(r);t<r;t++)n[t]=e[t];return n};
